<template>
    <div
        class="base-dot-link"
        :class="{
            'base-dot-link--active': active
        }"
    >
        <div class="base-dot-link__text">
            <slot />
        </div>
        <div class="base-dot-link__bullet">•</div>
    </div>
</template>

<script setup>
defineProps({
    active: {
        type: Boolean,
        default: true,
        required: false
    }
});
</script>

<style lang="less">
@import './BaseDotLink.less';
</style>